<template>
  <div class="anar">
    <h4 class="anar__h">The context he chose, not just joined.</h4>
    <p class="anar__sub">Carrara has the longest continuous anarchist tradition in Italy. Stroobant arrived in 1970, at the high tide.</p>
    <ol class="anar__list">
      <li v-for="e in events" :key="`${e.year}-${e.label}`" :class="{ 'is-emph': e.emphasis }">
        <div class="anar__yr">{{ e.year }}</div>
        <div class="anar__txt">{{ e.label }}</div>
      </li>
    </ol>
    <p class="anar__foot">
      In 1968 ~<strong>90% of Carrara and the surrounding region identified as anarchist</strong>. Stroobant arrived two years later. Three decades on, he directed seven students through their tribute to a Spanish anarchist martyr, on commission from the federation founded down the road in 1945.
    </p>
  </div>
</template>

<script setup lang="ts">
import { ANARCHIST_CARRARA } from '../../data/stroobant';
const events = ANARCHIST_CARRARA;
</script>

<style scoped>
.anar {
  padding: 1.4rem 1.6rem;
  background: rgba(27,27,31,0.04);
  border-left: 4px solid var(--slate);
  border-radius: 0 4px 4px 0;
}
.anar__h {
  font-family: var(--font-body);
  font-size: 1.4rem;
  font-weight: 600;
  margin: 0 0 0.3rem;
  color: var(--slate);
}
.anar__sub { font-size: 0.94rem; color: var(--granite); margin: 0 0 1rem; }
.anar__list {
  list-style: none; padding: 0; margin: 0;
  border-top: 1px solid var(--vein);
}
.anar__list li {
  display: grid;
  grid-template-columns: 100px 1fr;
  gap: 1rem;
  padding: 0.7rem 0;
  border-bottom: 1px solid var(--vein);
  align-items: baseline;
}
.anar__list li.is-emph { background: rgba(194,90,58,0.04); }
.anar__yr {
  font-family: var(--font-body);
  font-weight: 700;
  font-size: 1.05rem;
  color: var(--slate);
}
.anar__list li.is-emph .anar__yr { color: var(--accent); }
.anar__txt { font-size: 0.98rem; line-height: 1.5; color: var(--slate-soft); }
.anar__foot { font-size: 1rem; line-height: 1.6; margin: 1.2rem 0 0; color: var(--slate-soft); }
.anar__foot strong { color: var(--slate); font-weight: 600; }
</style>
